export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#0f7ccf',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://certificadopg.com.br/image-bank/Ponta-Grossa-Ajustado.png',
  favicon: '/cadeadosd.png',
}

export const seo = {
  titulo: 'Sindi lojas PG',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado ponta grossa',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
  sdConsulta: false,
}

export const footer = {
  is0800: false,
  telefone: '42 3224 2510',
  whatsapp: '42 99984 1116',
  botaoWhatsapp: '4299841116',
  number0800: '0800 600 2710',
  cidadeuf: 'Ponta Grossa/PR',
  bairro: 'Ronda',
  titulo: 'Certificado Digital em Ponta Grossa',
  rua: 'Avenida Visconde de Taunay',
  numero: '1050',
  complemento: '',
  cep: '84051-000',
  cnpj: '80.250.814/0001-13',
}

export const redes = {
  facebook: 'https://www.facebook.com/SindilojasPG/',
  instagram: 'https://www.instagram.com/sindilojaspg/',
  linkedin: 'https://www.linkedin.com/company/sindilojas-ponta-grossa/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
